module.exports = __webpack_public_path__ + "static/media/linkedInLogo.c24cde28.png";